import { ApiError } from "../api/client";
import { fa } from "./fa";

/**
 * The Persian reason for a failed API action. Every api error body carries a
 * stable machine-readable `code` (`API_ERROR_CODES` in `@bing/shared`), which
 * `createHttpApiClient` surfaces on the thrown `ApiError`; this maps it through
 * the `fa.errors` table so the user sees the REAL reason (e.g. «به دلیل مسدود
 * بودن، این کار ممکن نیست») instead of a bare «انجام نشد». Unknown codes and
 * non-API failures (network, bugs) fall back to the generic retry line.
 */
export function faApiError(error: unknown): string {
  if (error instanceof ApiError && error.code) return fa.errors[error.code];
  return fa.friends.actionError;
}
